import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams, PopoverController} from '@ionic/angular';

@Component({
  selector: 'app-modal-list-acoes-grid',
  templateUrl: './modal-list-acoes-grid.component.html',
  styleUrls: ['./modal-list-acoes-grid.component.scss'],
})
export class ModalListAcoesGridComponent {

  public listAcoes: any[] = [];

  constructor(private modalController: ModalController, private popoverController: PopoverController, private navParams: NavParams,) {
    this.listAcoes = this.navParams.get('acoes');
  }

  async selecionarAcao(ordernacaoSelecionada) {
    this.popoverController.dismiss(ordernacaoSelecionada);
  }

}
